import React from 'react'

export default function Portal({ props }) {
    const { portalUrl, sizing } = props
    return (
        <section className={`${sizing === "padded" ? "container py-8": ""}`}>
            {portalUrl ?
                <iframe className="h-[75vh] w-full border-none" lang="en" title="Portal" src={portalUrl}></iframe>
                : null}
        </section>
    )
}
